import { Link } from "react-router-dom";
import { Check, ArrowRight, Shield } from "lucide-react";

const features = [
  "3 richieste annuali",
  "Assistenza utenze (luce, gas, fibra)",
  "Supporto credito riservato agli abbonati",
  "Area Clienti dedicata",
  "Assistenza durante tutto l'anno",
];

export default function Piano() {
  return (
    <div data-testid="piano-page" className="bg-white">
      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-4xl px-6 text-center lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">Piano ViviTranquillo</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tighter text-[#0A192F] sm:text-5xl lg:text-6xl">
            Un abbonamento, tutto l'anno sereno
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-slate-600">
            Con €49 all'anno hai accesso ad assistenza utenze, supporto credito e alla tua Area Clienti.
          </p>
        </div>
      </section>

      <section className="pb-20 lg:pb-28">
        <div className="mx-auto max-w-2xl px-6 lg:px-8">
          <div className="overflow-hidden rounded-[2rem] border border-slate-200 shadow-[0_20px_60px_rgb(10,25,47,0.08)]">
            <div className="bg-[#0A192F] p-8 text-center">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.15em] text-[#10B981]">
                <Shield className="h-3.5 w-3.5" /> Piano Completo
              </span>
              <p className="mt-5 font-display text-6xl font-extrabold text-white">€49<span className="text-xl font-medium text-slate-400">/anno</span></p>
            </div>
            <div className="p-8 lg:p-10">
              <ul className="space-y-4">
                {features.map((f) => (
                  <li key={f} className="flex items-center gap-3 text-[#0A192F]">
                    <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#10B981]">
                      <Check className="h-4 w-4 text-white" />
                    </span>
                    <span className="font-medium">{f}</span>
                  </li>
                ))}
              </ul>
              <Link to="/registrazione" data-testid="piano-register-btn" className="mt-8 flex items-center justify-center gap-2 rounded-full bg-[#10B981] px-8 py-4 font-semibold text-white transition-colors hover:bg-[#059669]">
                Inizia ora <ArrowRight className="h-4 w-4" />
              </Link>
              <p className="mt-4 text-center text-sm text-slate-500">
                I preventivi assicurativi restano <strong>gratuiti e separati</strong> dal Piano.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
